export const RUN_TOUR_ON_PAGE_LOAD = false;

export const MAX_ITEMS_TO_DISPLAY = 5;

export const DISMISS_ACTIONS = ['skip', 'close'];

export const VIEW_CONTEXT = Object.freeze({ DEFAULT: 'home', ALL: 'all' });

export const STEP_FIELDS = Object.freeze({ CONTENT: 'content', FEATURE_TOUR_ID: 'feature_tour_id' });



// WEBPACK FOOTER //
// ./src/components/feature_tour/constants.jsx